import { defineStore } from 'pinia';
import { useTagStore } from './TagStore';
import { useResourceStore } from '@/store/ResourceStore';
import { useCollectionStore } from '@/store/CollectionStore';
import { usePermissionStore } from '@/store/PermissionStore';
import ApiService from '@/services/ApiService';
import { useModalStore } from './ModalStore';

export const useRMTStore = defineStore('RMT', {
  state () {
    return {
      uploadLoading: false,
      // for determine mode in save uploads
      isCollectionItemsChanged: false,
      isAddResource: false,
      removeResourcesTags: [],
      removeCollectionTags: [],
      removePermissionsTags: [],
      // Used in editing and creating collections
      cancelMode: 0,
      editCollectionId: [],
      editCollectionItems: [],
      displayCollectionItems: [],
      createdCollectionId: [],
      createdCollectionItems: [],
      inCreateCollectionMode: false,
      searchText: '',
      // we can remove these at some point now that the sort types have their own state
      resourceSortTypes: [
        { name: 'Alphabetic Ascending', isChecked: true },
        { name: 'Alphabetic Descending', isChecked: false },
        { name: 'Upload Date Ascending', isChecked: false },
        { name: 'Upload Date Descending', isChecked: false }
      ],
      collectionSortTypes: [
        { name: 'Alphabetic Ascending', isChecked: true },
        { name: 'Alphabetic Descending', isChecked: false }
      ],
      selectedMediaTypes: ['Photo', 'Video', 'Document'],
      mediaTypes: [
        { name: 'Photo', isChecked: true },
        { name: 'Video', isChecked: true },
        { name: 'Document', isChecked: true }
      ],
      limit: 28,
      page: 1,
      orderBy: 'name',
      orderDescending: false,
      // 0 = resources, 1 = collections
      searchType: 0,
      selectedCollectionColor: null,
      inUploadMode: false,
      colorOptions: ['#592121', '#a95e5e', '#e08840', '#8B8000', '#228B22', '#000080', '#b6c3dc', '#9a4fb0'],
      colors: ['#a95e5e', '#592121', '#e08840', '#b6c3dc', '#73a43e', '#9a4fb0', '#e08840'],
      saveCollectionResources: [],
      data: [
        {
          label: 'file name',
          placeholder: 'name_of_file.jpg',
          value: 'resourceUri',
        },
        { label: 'title', placeholder: 'Image Title', value: 'name' },
        {
          label: 'description',
          placeholder: 'Image Description',
          value: 'description',
        },
        { label: 'alt tag', placeholder: 'Alt tag', value: 'alt' },
      ],
      collectionData: [
        {
          label: 'name',
          placeholder: 'Collection Name',
          value: 'name'
        },
        {
          label: 'description',
          placeholder: 'Collection Description',
          value: 'description',
        },
      ],
      singleDate: new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate()), // todays date
      strings: [
        { type: 'tags', string: '' },
        { type: 'collections', string: '' },
        { type: 'permissions', string: '' },
      ],
      uploadedFiles: [],
      selectedItemNum: 0,
      uploadedFileData: [],
      showCollectionSearchDisplayType: 'showCollectionGrid',
      addCollectionSearchDisplayType: 'addCollectionGrid',
      editCollectionSearchDisplayType: 'editCollectionGrid',
      collectionSearchDisplayType: 'collectionGrid',
      resourcesPageY: 0,
      collectionsPageY: 0,
      inMultiSelectionMode: false,
      multiCount: 0,
      // TODO: set up get/set
      tagSelection: {
        tags: {
          all: [],
          shared: []
        },
        collections: {
          all: [],
          shared: []
        },
        permissions: {
          all: [],
          shared: []
        }
      },
      libraryItemData: {
        type: null,
        category: null
      },
      libraryTypes: [],
      libraryCategories: [],
      matrixMode: 'show',
      showAddGroup: false,
      editGroup: null,
      editTag: null,
      manageGroupMode: false,
      selectedTagAddGroup: null,
      searchDisplayType: 'grid',
      selectedGroup: null,
      panelIsHidden: true,
      scrollingPanel: window,
      showingSaved: false,
      RMTPermission: false,
      RMTEditMode: false,
      selectedCollections: [],
      selectedCollectionElement: null,
      selectedPermissions: [],
    };
  },
  getters: {
    getSelectedCollectionElement () { return this.selectedCollectionElement; },
    getMediaTypes () { return this.mediaTypes; },
    getSortTypes () {
      if (this.searchType == 0) {
        return this.resourceSortTypes;
      }
      return this.collectionSortTypes;
    },
    getSearchType () { return this.searchType; },
    getSearchDisplayType () { return this.searchDisplayType; },
    getCancelMode () { return this.cancelMode; },
    getShowCollectionSearchDisplayType () { return this.showCollectionSearchDisplayType; },
    getAddCollectionSearchDisplayType () { return this.addCollectionSearchDisplayType; },
    getEditCollectionSearchDisplayType () { return this.editCollectionSearchDisplayType; },
    getCollectionSearchDisplayType () { return this.collectionSearchDisplayType; },
    getShowingSaved () { return this.showingSaved; },
    getSelectedCollection () { return this.selectedCollection; },
    resources () {
      const resourceStore = useResourceStore();
      if (this.showingSaved) {
        return resourceStore.favoriteResources;
      }
      return resourceStore.resources;
    },
    selectedResources () {
      const resourceStore = useResourceStore();
      if (this.showingSaved) {
        return resourceStore.selectedFavoriteResources;
      }
      return resourceStore.selectedResources;
    },
    /*  selectedCollections () {
        const collectionStore = useCollectionStore();
        return collectionStore.selectedCollections;
      },*/
    uploads () {
      const resourceStore = useResourceStore();
      return resourceStore.uploads;
    },
    selectedUploads () {
      const resourceStore = useResourceStore();
      return resourceStore.uploadResources;
    },
    getUploadedFiles () { return this.uploadedFiles; },
    getSelectedItemNum () { return this.selectedItemNum; },
    getSelectedUploadedFileData () {

      if (this.inUploadMode) {
        return this.uploads[this.selectedItemNum];
      } else {
        return (this.searchType === 0) ? this.resources[this.selectedItemNum] : this.selectedCollections[0];
      }
    },
    getDefaultData () {

      return [
        {
          label: 'file name',
          placeholder: 'name_of_file.jpg',
          value: 'resourceUri',
        },
        {
          label: 'title',
          placeholder: 'Image Title',
          value: 'name'
        },
        {
          label: 'description',
          placeholder: 'Image Description',
          value: 'description',
        },
        { label: 'alt tag', placeholder: 'Alt tag', value: 'alt' },
      ];

    },
    getInMultiSelectionMode () { return this.inMultiSelectionMode; },
    getCollectionSelectedItems () { return this.createdCollectionItems; },
    getCollectionEditItems () { return this.editCollectionItems; },
    editCollectionCount () { return this.editCollectionItems.length; },
    addedCollectionCount () { return this.createdCollectionItems.length; },
    showCollectionCount () { return this.displayCollectionItems.length; },
    groupData () {
      const tagStore = useTagStore();
      return tagStore.groupData;
    },
    selectedTab () {
      const tagStore = useTagStore();
      return tagStore.getSelectedTab;
    },
    getTagData () {
      const tagStore = useTagStore();
      return tagStore.getTagData;
    },
    getTagsInSelectedGroup () {
      const tagStore = useTagStore();
      return tagStore.getTagsInSelectedGroup();
    },

    filterUploadResources () {
      const resourceStore = useResourceStore();
      return resourceStore.filterUploadResources;
    },
    tagsForSelectedResource () {
      if (this.selectedResources.length != 1) { return []; }
      const tagStore = useTagStore();
      return tagStore.getTagsById(this.selectedResources[0].tagIds);
    },
    isLoading () {
      const resourceStore = useResourceStore();
      const collectionStore = useCollectionStore();
      return resourceStore.isLoading || collectionStore.isLoading;
    },
    collections () {
      const collectionStore = useCollectionStore();
      return collectionStore.visibleCollections;
    },
    getDownloadCID () {
      const collectionStore = useCollectionStore();
      return collectionStore.downloadCID;
    }

  },
  actions: {
    setSelectedCollectionElement (e) {
      this.selectedCollectionElement = e;
    },

    getGroupTypeId (type) {

      let groupId;

      switch (type) {
        case 'tags':
          groupId = 'tagIds';
          break;
        case 'collections':
          groupId = 'collections';
          break;
        case 'permissions':
          groupId = 'subscriptions';
          // groupId = 'permissions';
          break;
      }
      return groupId;
    },

    getTypeId (type) {

      let typeId;

      switch (type) {
        case 'tags':
          typeId = 'tagId';
          break;
        case 'collections':
          typeId = 'cID';
          break;
        case 'permissions':
          typeId = 'subscriptionId';
          break;
      }
      return typeId;

    },

    getAssociationsById (type) {

      const tagStore = useTagStore();
      const collectionStore = useCollectionStore();
      const permissionStore = usePermissionStore();

      let t = [];
      switch (type) {
        case 'tags':
          t = tagStore.getTagsById(this.tagSelection.tags.all);
          break;

        case 'collections':
          t = collectionStore.getCollectionsById(this.tagSelection.collections.all);
          break;

        case 'permissions':
          t = permissionStore.getPermissionsById(this.tagSelection.permissions.all);
          break;

      }
      return t;

    },
    created () {
      this.filterResources();
      this.filterCollections();
      const tagStore = useTagStore();
      tagStore.fetchTags();
      tagStore.fetchGroups();
    },
    setPanelIsHidden (bool) {
      this.panelIsHidden = bool;
    },
    selectAllResources () {
      const resourceStore = useResourceStore();
      if (this.showingSaved) {
        resourceStore.selectAllFavorites();
      } else {
        resourceStore.selectAll();
      }
    },
    selectAllUploads () {
      const resourceStore = useResourceStore();
      resourceStore.selectAllUploads();
    },
    toggleShowingSaved () {
      this.showingSaved = !this.showingSaved;
    },
    async resourcesForCollection (collection) {
      const resourceStore = useResourceStore();
      return resourceStore.resourcesForCollection(collection, this.page, this.limit);
    },
    toggleMultiSelectionMode () {
      this.inMultiSelectionMode = !this.inMultiSelectionMode;
    },
    clearSelections () {
      this.clearSelectedResources();
      this.clearSelectedCollections();
    },
    clearSelectedResources () {
      const resourceStore = useResourceStore();
      resourceStore.clearSelected();
    },
    clearSelectedUploads () {
      const resourceStore = useResourceStore();
      resourceStore.clearSelectedUploads();
    },
    saveFavorites () {
      const resourceStore = useResourceStore();
      resourceStore.saveFavorites();
    },
    clearSelectedCollections () {
      const collectionStore = useCollectionStore();
      collectionStore.clearSelected();
    },
    async filterCollections (event) {
      if (event === 'reset page') {
        this.page = 1;
        if (this.searchType === 0) {
          this.updateSortCriteria(event.target.value);
        }
      }
      const collectionStore = useCollectionStore();
      await collectionStore.filterCollections(this.page, this.limit, this.searchText, this.orderBy, this.orderDescending);
    },
    async filterResources (event) {
      if (event === 'reset page') { this.page = 1; }
      let selectedMediaTypes = this.mediaTypes.filter((m) => { if (m.isChecked) { return m; } });
      this.selectedMediaTypes = [];
      for (let m in selectedMediaTypes) { this.selectedMediaTypes.push(selectedMediaTypes[m].name); }
      // TODO: do we need this code now that the media types have been updated and we're not longer using the strings as sorting criteria?
      let params = this.selectedMediaTypes;
      const resourceStore = useResourceStore();
      await resourceStore.getResources(this.page, this.limit, params, this.searchText, this.orderBy, this.orderDescending);
    },
    updateSortCriteria (sortName) {
      if (sortName == 'Alphabetic Ascending') {
        this.orderBy = 'name';
        this.orderDescending = false;
      } else if (sortName == 'Alphabetic Descending') {
        this.orderBy = 'name';
        this.orderDescending = true;
      } else if (sortName == 'Upload Date Ascending') {
        this.orderBy = 'dateAddedUtc';
        this.orderDescending = false;
      } else if (sortName == 'Upload Date Descending') {
        this.orderBy = 'dateAddedUtc';
        this.orderDescending = true;
      }
    },
    setSortOrderBy (str) {
      this.orderBy = str;
      this.page = 1;
    },
    setSortDescending (bool) {
      this.orderDescending = bool;
      this.page = 1;
    },
    fetchPage () {
      this.page += 1;
      // const collectionStore = useCollectionStore();
      if (this.searchType === 0) {
        this.filterResources();
        /* } else if (collectionStore.visibleCollections.length === 1) {
          const collection = collectionStore.visibleCollections[0];
          if (collection.resourcePks.length != collection.resources.length) {
            this.resourcesForCollection(collectionStore.visibleCollections[0]);
          }*/
      } else {
        if (this.inCreateCollectionMode) {
          this.filterResources();
        } else {
          this.filterCollections();
        }
      }
    },
    setSearchDisplayType (str) {
      this.searchDisplayType = str;
    },

    async removeCollection (collectionId) {

      return await ApiService.removeCollection(collectionId)
        .then(() => {
        })
        .catch((error) => {
          console.log(error);
        });
    },
    async collectionLinkResources (collectionId, resources) {
      return await ApiService.collectionLinkResources(collectionId, resources)
        .then(() => {
          this.filterCollections();
          this.saveCollectionResources = [];
          this.createdCollectionItems = [];
          this.createdCollectionId = [];
        })
        .catch((error) => {
          console.log(error);
        });
    },
    async collectionUnlinkResources (collectionId, resources) {
      return await ApiService.collectionUnlinkResources(collectionId, resources)
        .then(() => {
          this.editCollectionItems = [];
          this.editCollectionId = [];
          this.filterCollections();
        })
        .catch((error) => {
          console.log(error);
        });
    },
    async deleteResource (resourceId) {
      return await ApiService.deleteResource(resourceId)
        .catch((error) => {
          console.log(error);
        });
    },

    async fetchLibraryTypes () {
      return await ApiService.fetchLibraryTypes()
        .then((response) => {
          this.libraryTypes = response.data;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    async fetchLibraryCategories () {
      return await ApiService.fetchLibraryCategories()
        .then((response) => {
          this.libraryCategories = response.data;
        })
        .catch((error) => {
          console.log(error);
        });
    },

    setCurrentLibraryType (item) {

      this.libraryItemData.type = item;

    },
    setCurrentLibraryCategory (item) {

      this.libraryItemData.category = item;

    },
    setCollectionSelectedItems (items) {
      this.createdCollectionItems.push(items);
    },
    clearAll () {
      this.isEdit = false;
      this.uploadedFiles = [];
      this.uploadedFileData = [];
      this.clearSelectedResources();
      this.setPanelIsHidden(true);
      this.RMTEditMode = false;
    },

    uploadCancel () {
      this.clearSelectedResources();
      this.setPanelIsHidden(true);
      this.setSelectedItemNum(0);
      this.data = this.getDefaultData;
      this.inUploadMode = false;
      this.uploadedFileData = [];
    },

    removeFromIncluded (tag, type) {
      // TODO: this should be a unique identifier / key

      tag.recent = false;
      switch (type) {
        case 'tags':
          this.getSelectedUploadedFileData.tagIds = this.getSelectedUploadedFileData.tagIds.filter((t) => t !== tag.tagId);
          break;
        case 'collections':
          this.getSelectedUploadedFileData.collections = this.getSelectedUploadedFileData.collections.filter((t) => t !== tag.cID);
          break;
        case 'permissions':
          // Brett to add functionality here depending on how he structures subscriptions/permissions
          this.getSelectedUploadedFileData.subscriptions = this.getSelectedUploadedFileData.subscriptions.filter((t) => t !== tag.subscriptionId);
          break;
      }
    },
    isIncluded (tag, type) {
      if (this.getSelectedUploadedFileData === undefined) { return; }
      let t;
      switch (type) {
        case 'tags':
          t = this.getSelectedUploadedFileData.tagIds.findIndex((t) => t === tag.tagId);
          break;
        case 'collections':
          t = this.getSelectedUploadedFileData.collections.findIndex((t) => t === tag.cID);
          break;
        case 'permissions':
          // Brett to add functionality here depending on how he structures subscriptions/permissions
          t = this.getSelectedUploadedFileData.subscriptions.findIndex((t) => t === tag.subscriptionId);
          break;
      }
      return t > -1;
    },
    setString (type, str) {
      let s = this.strings.find((str) => str.type === type);
      s.string = str;
    },
    setSearchText (text) {
      if (text === undefined) { return; }
      this.searchText = text;
      this.page = 1;
      if (this.searchType === 0 || this.inCreateCollectionMode) {

        this.filterResources().catch(error => {
          // todo: route to error display
          console.log('Error: ' + JSON.stringify(error));
        });

      } else {

        this.filterCollections().catch(error => {
          // todo: route to error display
          console.log('Error: ' + JSON.stringify(error));
        });
      }
    },
    selectionChanged (type, isMultiSelect, resource) {
      if (type === 'upload') {
        if (isMultiSelect) {
          resource.isSelected = !resource.isSelected;
          this.uploadedFileData = [];
          this.uploadedFileData = this.updateAssociations(this.selectedUploads);
          this.uploadedFileData[0].libraryType = null;
          this.uploadedFileData[0].libraryCategory = null;
        } else {
          if (this.uploadedFileData[0].isMulti) {
            this.selectedUploads.forEach((element) => {
              this.uploadedFileData[0].tagIds.forEach((tag) => {
                if (!element.tagIds.includes(tag)) {
                  element.tagIds.push(tag);
                }
              });
              // removes tags
              this.removeResourcesTags.forEach((tag) => {
                element.tagIds = element.tagIds.filter((id) => id != tag);
              });
              this.uploadedFileData[0].collections.forEach((collection) => {
                if (!element.collections.includes(collection)) {
                  element.collections.push(collection);
                }
              });
              this.removeCollectionTags.forEach((collection) => {
                element.collections = element.collections.filter((id) => id != collection);
              });
              this.removePermissionsTags.forEach((permission) => {
                element.permissions = element.subscriptions.filter((id) => id != permission);
              });
            });
          }
          if (resource.isSelected) {
            this.clearSelectedUploads();
            resource.isSelected = true;
          }
          else {
            this.clearSelectedUploads();
            resource.isSelected = true;
          }
          this.uploadedFileData = [...this.selectedUploads];
        }
      } else {
        this.data = this.getDefaultData;
      }
    },
    updateSelection (type) {

      let all = [];
      let shared = [];

      let groupId = this.getGroupTypeId(type);
      let resources = [];

      if (this.searchType === 0) {
        resources = (!this.inUploadMode) ? this.selectedResources : this.selectedUploads;
      } else {
        resources = this.selectedCollections;
      }

      resources.forEach((s) => {

        if (s[groupId] === undefined) {
          s[groupId] = [];
        }

        s[groupId].forEach((id) => {

          if (type === 'permissions') {
            id = usePermissionStore().getIdFromSubscriptionValue(id);
          }
          all.push(id);

        });

      });

      let counts = {};
      all.forEach(function (x) {
        counts[x] = (counts[x] || 0) + 1;
      });

      let keys = Object.keys(counts);
      keys.forEach((key) => {
        if (counts[key] === resources.length) {
          shared.push(parseInt(key));
        }
      });

      all = [...new Set(all)];

      // TODO: set up get/set
      this.tagSelection[type].all = all;
      this.tagSelection[type].shared = shared;

    },

    updateLibraryData () {

      // todo: DO NOT DELETE
      // todo: disabling drop down library data until backend supported
      /*   let resources = (!this.inUploadMode) ? this.selectedResources : this.selectedUploads;
   
         // todo : do not display if in multiple select or upload
         let libraryType = this.getLibraryTypeFromId(resources[0].libTypeId);
         let libraryCategory = this.getLibraryCategoryFromId(resources[0].libCategoryId);
   
         this.libraryItemData.type = libraryType;
         this.libraryItemData.category = libraryCategory;*/

    },

    getLibraryTypeFromId (id) {
      return this.libraryTypes.find((type) => type.libraryTypeId === id);
    },

    getLibraryCategoryFromId (id) {

      // todo: fix hack
      if (id === 0) {
        id = 1;
      }

      return this.libraryCategories.find((category) => category.libraryCategoryId === id);
    },

    updateAssociations () {

      this.updateSelection('tags');
      this.updateSelection('collections');
      this.updateSelection('permissions');
      this.updateLibraryData();

    },

    syncTag (tag, type) {

      let typeId = this.getTypeId(type);
      let groupId = this.getGroupTypeId(type);

      let resources = [];

      if (this.searchType === 0) {
        resources = (!this.inUploadMode) ? this.selectedResources : this.selectedUploads;
      } else {
        resources = this.selectedCollections;
      }

      resources.forEach((resource) => {
        if (resource[groupId].indexOf(tag[typeId]) === -1) {
          resource[groupId].push(tag[typeId]);
        }
      });

      this.updateAssociations();

    },

    addKeywordToSelection (option, type) {

      let typeId = this.getTypeId(type);
      let groupId = this.getGroupTypeId(type);

      let resources = [];

      if (this.searchType === 0) {
        resources = (!this.inUploadMode) ? this.selectedResources : this.selectedUploads;
      } else {
        resources = this.selectedCollections;
      }

      resources.forEach((resource) => {

        let value = option[typeId];

        if (type === 'permissions') {
          value = usePermissionStore().getValueFromSubscriptionId(value);
        }

        if (resource[groupId].indexOf(value === -1)) {
          resource[groupId].push(value);
        }
      });

      this.updateAssociations();

    },
    removeKeywordFromSelection (option, type) {

      let typeId = this.getTypeId(type);
      let groupId = this.getGroupTypeId(type);

      let resources = [];

      if (this.searchType === 0) {
        resources = (!this.inUploadMode) ? this.selectedResources : this.selectedUploads;
      } else {
        resources = this.selectedCollections;
      }

      resources.forEach((resource) => {

        let value = option[typeId];

        if (type === 'permissions') {
          value = usePermissionStore().getValueFromSubscriptionId(value);
        }
        resource[groupId] = resource[groupId].filter((resource) => resource !== value);
      });

      this.updateAssociations();

    },

    getMatchingAssociations (type) {

      const tagStore = useTagStore();
      const collectionStore = useCollectionStore();
      const permissionStore = usePermissionStore();

      let typeId = this.getTypeId(type);

      let data;
      let name;

      switch (type) {
        case 'tags':
          data = tagStore.tagData;
          name = 'tag';
          break;
        case 'collections':
          data = collectionStore.visibleCollections;
          name = 'name';
          break;
        case 'permissions':
          data = permissionStore.getPermissionData;
          name = 'name';
          break;
      }

      let strEntry = this.strings.find((str) => str.type === type).string.toLowerCase();
      let f = [];
      for (let a = 0; a < data.length; a++) {
        let t = data[a];
        let i = this.tagSelection[type].all.findIndex((tagId) => tagId === t[typeId]);
        if (i === -1) {
          if (t[name].toLowerCase().includes(strEntry)) {
            f.push(t);
          }
        }
      }
      return f;

    },

    clearAssociations () {

      this.tagSelection = {
        tags: {
          all: [],
          shared: []
        },
        collections: {
          all: [],
          shared: []
        },
        permissions: {
          all: [],
          shared: []
        }
      };
    },
    removeResourceFromCollection (resource) {
      this.selectedCollections[0].resources =
        this.selectedCollections[0].resources.filter((r) => r.key !== resource.key);

      this.selectedCollections[0].resourcePks =
        this.selectedCollections[0].resourcePks.filter((r) => r !== resource.key);

    },


    // deals with editing and creating a new collection
    // setUploadedCollections () {

    /*      this.uploadedFileData = [];
    this.data = [
      { label: 'title', placeholder: 'Collection Title', value: 'title' },
      {
        label: 'description',
        placeholder: 'Collection Description',
        value: 'description',
      },
    ];
    for (let a = 0; a < arr.length; a++) {
      this.uploadedFileData.push(arr[a]);
    }*/

    // },
    // deals with editing resources
    setUploadedFiles () {
      this.uploadedFileData = [];
      const resourceStore = useResourceStore();
      const selections = resourceStore.selectedResources;

      for (let a = 0; a < selections.length; a++) {
        this.uploadedFileData.push({
          key: selections[a].key,
          contentSource: selections[a].contentSource,
          id: selections[a].id,
          isActive: selections[a].isActive,
          nicpn: selections[a].nicpn,
          group: selections[a].group,
          name: selections[a].name,
          alt: selections[a].alt,
          description: selections[a].description,
          resourceUri: selections[a].resourceUri,
          libTypeId: selections[a].libTypeId,
          libCategoryId: selections[a].libCategoryId,
          subscription: selections[a].subscription,
          // TODO: remove permission and assign to subscription?
          permissions: [],
          collections: selections[a].collections,
          dateAddedUtc: selections[a].dateAddedUtc,
          tagIds: selections[a].tagIds,
        });
      }
    },
    setSelectedItemNum (num) {
      this.selectedItemNum = num;
    },
    setPageY (type, val) {
      console.log(type);
      if (type === 0) {
        this.resourcesPageY = val;
        window.scrollTo(0, this.collectionsPageY);
      } else if (type === 1) {
        this.collectionsPageY = val;
        setTimeout(() => {
          window.scrollTo(0, this.resourcesPageY);
        }, 1);
      }
    },
    setRMTSearchType (type) {
      if (type === 0) {
        this.data = this.getDefaultData;
      }
      this.inMultiSelectionMode = false;
      this.searchType = type;
    },
    setCollectionSearchDisplayType (type) {
      this.collectionSearchDisplayType = type;
    },
    setEditCollectionSearchDisplayType (type) {
      this.editCollectionSearchDisplayType = type;
    },
    setAddCollectionSearchDisplayType (type) {
      this.addCollectionSearchDisplayType = type;
    },
    setShowCollectionSearchDisplayType (type) {
      this.showCollectionSearchDisplayType = type;
    },
    setCancelMode (number) {
      this.cancelMode = number;
    },
    cancelPrompt () {
      const modalStore = useModalStore();
      modalStore.hideModal();
    },
    saveStuff () {
      if (this.inUploadMode === true) {
        const resourceStore = useResourceStore(); 
        resourceStore.bulkUpload(this.uploads);
      } else if (this.inCreateCollectionMode === true) {
        this.saveCreatedCollection();
      } else if (this.searchType === 1) { // collections mode
        this.saveCreatedCollection();
      } else if (this.inMultiSelectionMode === true || this.selectedResources.length > 1) {
        this.saveEditedResources();
      } else {
        this.saveEditedResource();
      }
      // todo: implement call to merge uploadedFiles and uploadedData into format for API endpoint
      if (!this.inUploadMode) {
        // this.clearAll();
        // this.setPanelIsHidden(true);
        // TODO : add feedback snack bar
      }
    },

    saveCreatedCollection () {

      // todo: legacy code - delete once updated functionality is validated
      /*      this.uploadedFileData[0].resources = [...this.createdCollectionItems];
            this.saveCollectionResources = [{ collectionItems: [...this.createdCollectionItems], collectionTags: this.uploadedFileData[0].tagIds }];
            const formatCollectionData = [{ cID: 0, name: this.uploadedFileData[0].title, subscription: null, description: this.uploadedFileData[0].description, color: this.selectedCollectionColor }];
            // creating a new collection
            this.setCollection(formatCollectionData[0]);*/

      let collection = this.selectedCollections[0];
      let resources = this.selectedResources;

      let collectionCopy = JSON.parse(JSON.stringify(collection));

      // collection.resources = resources;
      delete collectionCopy.resources;
      delete collectionCopy.collections;

      if (collectionCopy.isSelected) {
        delete collectionCopy.isSelected;
      }

      let resourcePks = [];
      resources.forEach((resource) => {
        resourcePks.push(resource.key);
      });

      collectionCopy.resourcePks = resourcePks;

      collectionCopy.color = this.selectedCollectionColor;

      this.setCollection(collectionCopy);

    },

    async setCollection (collection) {

      return await ApiService.setCollection(collection)
        .then(() => {

          this.selectedCollections[0].isSelected = false;
          const modalStore = useModalStore();
          modalStore.showSnack('Collection Saved.');
          this.resetCollectionView();
          this.filterCollections('reset page');

        })
        .catch((error) => {
          console.log(error);
        });
    },

    resetCollectionView () {

      this.clearAll();
      this.uploadCancel();
      this.inMultiSelectionMode = false;
      if (this.inCreateCollectionMode) {
        this.inCreateCollectionMode = false;
      }

    },

    populateCollectionItemQueue () {

      let collection = this.selectedCollections[0];
      collection.resources.forEach((resource) => {
        resource.isSelected = true;
      });
      useResourceStore().filteredResources.push(...collection.resources);


    },

    saveEditedResources () {

      this.multiCount = this.selectedResources.length - 1;
      this.saveEditedResource(this.multiCount);

    },
    saveEditedResource (num) {
      if (num === undefined) {
        num = 0;
      }

      let resource = (!this.inUploadMode) ? this.selectedResources[num] : this.uploads[num];

      // todo: do not delete - library/category drop downs are commented out until backend functionality is in place
      if (this.inUploadMode) {

        // get library values
        console.log(this.libraryItemData, ' library item data');

        resource.libTypeId = this.libraryItemData.type.libraryTypeId;
        resource.libCategoryId = this.libraryItemData.category.libraryCategoryId;

        // // todo: hack until backend is fixed with appropriate data
        // if (resource.libCategoryId === 0) {resource.libCategoryId = 1;}

      }
      console.log(resource);
      this.editResource(resource).then(() => {

        if (this.multiCount > 0) {
          this.multiCount--;
          this.saveEditedResource(this.multiCount);

        } else {
          this.clearAll();
          this.uploadCancel();
          this.inMultiSelectionMode = false;
          const modalStore = useModalStore();
          modalStore.showSnack('Resource Saved.');
          this.filterResources();
        }
      });

    },

    async editResource (resource) { // , type, blob, index, count) {

      const collectionIds = resource.collections;
      console.log(resource);
      console.log(this.inUploadMode);
      var typeResource = {};
      if (this.inUploadMode) {
        console.log(resource);
        typeResource = {
          key: null,
          id: resource.id,
          isActive: true,
          nicpn: null,
          group: null,
          name: resource.name,
          alt: resource.alt,
          description: resource.description,
          resourceUri: resource.name,
          subscription: [],
          collections: resource.collections,
          dateAddedUtc: resource.date,
          libTypeId: resource.libTypeId,
          libraryCategoryId: resource.libCategoryId,
          tagIds: resource.tagIds
        };
      } else if (!this.inUploadMode) {
        typeResource = resource;
      }
      await ApiService.editResource(typeResource)
        .then((result) => {
          return result.data;
        })
        .then((response) => {
          if (this.inUploadMode) {

            const resourcePk = response.data.key;

            // link collections
            collectionIds.forEach((cID) => {
              this.collectionLinkResources(cID, [resourcePk]);
            });

            this.uploadResource(resource, response).then((response) => {
              return response;
            });

          } else {
            return response;
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    //  async uploadResource (resourcePk, resourceUri, type, blob, index, count) {
    async uploadResource (resource, response) {

      let resourcePk = response.key;
      let resourceUri = response.resourceUri;
      let blob = resource.fileBlob;

      await ApiService.uploadResource(resourcePk, resourceUri, '.jpg', blob)
        .then((response) => {
          console.log(response, ' response');
          return response;
          /* this.filterResources();
           if (count == index) {
             this.uploadedFileData = [];
             const resourceStore = useResourceStore();
             resourceStore.filterUploadResources = [];
             this.data = [
               { label: 'file name', placeholder: 'name_of_file.jpg', value: 'resourceUri' },
               { label: 'title', placeholder: 'Image Title', value: 'name' },
               { label: 'description', placeholder: 'Image Description', value: 'description' },
               { label: 'alt tag', placeholder: 'Alt tag', value: 'alt' }
             ];
             this.clearAll();
             this.setPanelIsHidden(true);*/
          /*            const modalStore = useModalStore();
                      modalStore.showSnack('Resource Saved.');
                      this.inUploadMode = false;*/
          // }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    getGroupById (group) {
      const tagStore = useTagStore();
      return tagStore.getGroupById(group);
    },
    resetCreateTag () {
      this.editTag = null;
    },
    deleteGroup (tagId) {
      const tagStore = useTagStore();
      return tagStore.deleteGroup(tagId);
    },
    setSelectedTab (num) {
      const tagStore = useTagStore();
      return tagStore.setSelectedTab(num);
    },
    setSelectedGroup (obj) {
      this.selectedGroup = obj;
    },
    clearSelectedGroup () {
      this.selectedGroup = null;
    },
    removeTag (tagId) {
      const tagStore = useTagStore();
      return tagStore.removeTag(tagId);
    },
    updateGroup (group) {
      const tagStore = useTagStore();
      return tagStore.updateGroup(group);
    },
    createTag (obj) {
      const tagStore = useTagStore();
      return tagStore.createTag(obj);
    },
    updateTag (obj) {
      const tagStore = useTagStore();
      return tagStore.updateTag(obj);
    },
    downloadResourcesZip () {
      const resourceStore = useResourceStore();
      return resourceStore.downloadResourcesZip(this.selectedResources);
    },
    downloadCollectionZip (collectionID) {
      const collectionStore = useCollectionStore();
      const resourceStore = useResourceStore();
      var promises = [];
      var collect = collectionStore.filteredCollections.filter(obj => {
        return obj.cID === collectionID;
      });
      if (collect.length > 0) {
        // call for all resources
        promises.push(resourceStore.resourcesForCollection(collect[0], 1, collect[0].resourcePks.length));
        promises.push(collectionStore.downloadCollectionZip(collect[0]));
        var finalPromise = Promise.all(promises);
        finalPromise.then((results) => {
          // check results
          console.log(results, 'download results');
        });
      }
      else {
        alert('Collection not found! Cannot download.');
        return;
      }
    },
  },
});
